/**
 * Hook de datos del **estado de todos los talonarios** (`GET /api/v1/talonarios`).
 *
 * Datos de servidor -> TanStack Query (`docs/frontend_conventions.md`, Datos): no
 * se usa `useState`+`useEffect`+`fetch` a mano. La query key incluye la sede
 * activa para cachear por sede. La red la gobierna `lib/api` (cookie httpOnly +
 * `X-Sede-Id`).
 */
import { useQuery } from "@tanstack/react-query";

import { getActiveSedeId } from "@/lib/sede";

import { fetchTalonarios } from "../api";
import type { TalonariosList } from "../types";
import { talonariosListQueryKey } from "./queryKeys";

export function useTalonarios() {
  const sedeId = getActiveSedeId();
  return useQuery<TalonariosList>({
    queryKey: talonariosListQueryKey(sedeId),
    queryFn: fetchTalonarios,
    staleTime: 15_000,
  });
}
